import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Gym } from 'src/app/model/gym';
import { DownloadService } from 'src/app/service/download.service';

export interface GymDetailsJsonDialogData {
  gymDetails: Gym;
}

@Component({
  selector: 'gymfinder-gym-details-json-dialog',
  templateUrl: './gym-details-json-dialog.component.html',
  styleUrls: ['./gym-details-json-dialog.component.scss'],
  standalone: false,
})
export class GymDetailsJsonDialogComponent implements OnInit {
  gymDetails: Gym;

  downloadFileName: string;

  constructor(
    private dialogRef: MatDialogRef<GymDetailsJsonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: GymDetailsJsonDialogData,
    private downloadService: DownloadService
  ) {}

  ngOnInit(): void {
    this.gymDetails = this.data.gymDetails;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public downloadFile() {
    const fileContent = JSON.stringify(this.gymDetails, null, 2);
    const fileName = `gym_${this.gymDetails.gymId}.json`;
    this.downloadService.download(fileContent, fileName, 'application/json');
  }
}
